module.exports = __webpack_public_path__ + "img/www.dealerrater.com.8a4edd0f.png";